export default __webpack_public_path__ + "static/media/czechRepublic.f791bf82.svg";